import { Table, Column, FieldType, Section } from "../../../../../features/ui"
import { Discount } from "../../../types"

type Props = {
    bonusesData: Partial<Discount>[]
    readOnly?: boolean
    space?: number
    onCreate?: () => void
    onEditBonus?: (name: string) => void
    onRemoveBonus?: (name: string) => void
}

export const DiscountTable = (props: Props) => {
    const { bonusesData, readOnly, space = 12, onCreate, onEditBonus, onRemoveBonus } = props

    const columns: Column[] = [
        {
            name: 'name',
            type: FieldType.TEXT,
            label: 'Nombre'
        },
        {
            name: 'yield',
            type: FieldType.PERCENTAGE,
            label: 'Porcentaje'
        }
    ]

    return (
        <Section
            id="bonuses"
            title="Bonificaciones"
            space={space}
            collapsable
            defaultExpanded
        >
            <Table
                columns={columns}
                rows={bonusesData.sort((a, b) => a.name!.localeCompare(b.name!))}
                rowId='name'
                readOnly={readOnly}
                createIcon="plus"
                small
                onCreate={onCreate}
                onEdit={onEditBonus}
                onRemove={onRemoveBonus}
            />
        </Section>
    )
}
